import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/conversations';

export async function get(id: number): Promise<Record<string, any>> {
	const response: Response = await BBApi.get(rootUrl + `/${id}`);

	if (response.ok === false) {
		throw new Error('Conversation not found');
	}

	const conversation: Record<string, any> = await response.json();
	return conversation;
}

export async function create(post: Record<string, any>): Promise<Record<string, any>> {
	throw new Error('Not implemented');
}

export async function update(id: number, status: number): Promise<void> {
	const response: Response = await BBApi.put(rootUrl + `/${id}`, { status });

	if (response.ok === false) {
		throw new Error('Conversation not updated');
	}
}

export async function remove(id: number): Promise<void> {
	throw new Error('Not implemented');
}
